import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from '../src/components/pages/index1'; 
import Service from '../src/components/pages/services'; 
import About from '../src/components/pages/about';
import Shop from '../src/components/pages/shop';
import Shop2 from '../src/components/pages/shop2';
import JeenaHead from "../src/layout/JeenaHead";

// Import your CSS files
import './assets/css/style.css';
import './assets/css/slick.min.css';
import './assets/css/nice-select.min.css';
import './assets/css/magnific-popup.min.css';
import './assets/css/fontawesome-5.14.0.min.css';
import './assets/css/flaticon.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/animate.min.css';
import './assets/css/sections/_cart-checkout.css';

function App() {
  return (
    <Router>
      {/* Include the JeenaHead component here */}
      <JeenaHead />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop2" element={<Shop2 />} />
      </Routes>
    </Router>
  );
}

export default App;
